import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'

// 高德地图配置
import VueAMap, { initAMapApiLoader } from '@vuemap/vue-amap'
import '@vuemap/vue-amap/dist/style.css'

// 初始化高德地图API加载器
// 您需要申请自己的高德地图Key
// 申请地址：https://lbs.amap.com/dev/key/app
initAMapApiLoader({
  key: 'd3967bb3a88576edf5287fd51fb4272f',  // 这是一个测试Key，请替换为您的高德地图Key
  version: '2.0',
  plugins: ['AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Geolocation'],
  // 安全配置
  securityJsCode: 'a00f6af327f9cb6ef872da0bb2fa6c33',  // 如果需要安全密钥，请填写
  // 服务配置
  serviceHost: ''  // 自定义服务域名，如果需要
})

// 创建axios实例
const app = createApp(App)

// 全局API基础URL
// 根据环境变量设置API地址
const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? '/api'  // 开发环境使用代理
  : 'https://erp.dynamic365.cn'  // 生产环境使用完整地址

const http = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'token': localStorage.getItem('token') || ''
  }
})

// 挂载全局变量
app.config.globalProperties.$apiBaseUrl = API_BASE_URL

// 请求拦截器
http.interceptors.request.use(config => {
  // 每次请求都更新token
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.token = token
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
http.interceptors.response.use(response => {
  return response.data
}, error => {
  // 处理401状态码 - 未授权，跳转到登录页面
  if (error.response && error.response.status === 401) {
    // 清除本地存储的token
    localStorage.removeItem('token')
    // 跳转到登录页面
    router.push('/login')
  }
  return Promise.reject(error)
})

app.use(ElementPlus)
// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store)
app.use(router)
// 使用高德地图
app.use(VueAMap)

// 挂载axios到Vue实例
app.config.globalProperties.$axios = http

app.mount('#app')
